import Nav from "@/components/Nav";
import Hero from "@/components/Hero";
import About from "@/components/About";
import Building from "@/components/Building";
import Path from "@/components/Path";
import Notes from "@/components/Notes";
import Press from "@/components/Press";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";

export default function App() {
  return (
    <div className="min-h-screen bg-navy text-white antialiased">
      <Nav />
      <main id="main">
        <Hero />
        <About />
        <Building />
        <Path />
        <Notes />
        <Press />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
